import {Directive, Input, OnInit, ViewContainerRef} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {InputComponent} from "../dynamic-input/input.component";
import {ButtonComponent} from "../dynamic-button/button.component";
import {SelectComponent} from "../dynamic-select/select.component";
import {DateComponent} from "../date/date.component";
import {RadiobuttonComponent} from "../dynamic-radiobutton/radiobutton.component";
import {CheckboxComponent} from "../dynamic-checkbox/checkbox.component";
import {FieldConfig} from "../../../interfaces/field.interface";

const componentMapper = {
    input: InputComponent,
    button: ButtonComponent,
    select: SelectComponent,
    date: DateComponent,
    radiobutton: RadiobuttonComponent,
    checkbox: CheckboxComponent
};

@Directive({
    selector: "[dynamicField]"
})
export class DynamicFieldDirective implements OnInit {
    @Input() field: FieldConfig;
    @Input() group: FormGroup;
    componentRef: any;

    constructor(private container: ViewContainerRef) {
    }

    ngOnInit() {
        this.componentRef = this.container.createComponent(componentMapper[this.field.type]);
        this.componentRef.instance.field = this.field;
        this.componentRef.instance.group = this.group;
    }
}
